import { createContext, useReducer, useContext } from 'react';
import EditorReducer from '../reducers/EditorReducer';
import EditorState from '../data/state/EditorState';

const EditorStateContext = createContext(EditorState);
const EditorDispatchContext = createContext(null);

function EditorContextProvider({ children }) {
  const [state, dispatch] = useReducer(EditorReducer, EditorState);

  return (
    <EditorStateContext.Provider value={state}>
      <EditorDispatchContext.Provider value={dispatch}>
        {children}
      </EditorDispatchContext.Provider>
    </EditorStateContext.Provider>
  );
}

export default EditorContextProvider;

export const useEditorStateContext = () => useContext(EditorStateContext);
export const useEditorDispatchContext = () => useContext(EditorDispatchContext);
